import * as React from "react";
import * as _ from "lodash";

import {DashboardCard} from "./Card";
import {orderCategories} from "./list";
import {FAVORITE_DASHBOARDS, ALL_DASHBOARDS} from "../../../utils/constans";
import {useFeatureGatingEnabled} from "@/hooks/feature-gating";
import {Dashboard as DashboardType, DashboardCategoryDict, DashboardsResponse} from "@/hooks/dashboard";
import {KeyedMutator} from "swr";
import {useAppContext} from "@/contexts/app";
import {EAIClient} from "Services/EAIClient";
import {Utils} from "../../common/utils";
import { useToast } from "@/hooks/useToast";


export interface DashboardCategoryProps {
    cards: DashboardType[]
    name: string
    orderBy: orderCategories
    favorites: DashboardType[]
    categories: DashboardCategoryDict | null
    mutate: KeyedMutator<DashboardsResponse>
    onClickDelete?: (dashboardName: string, dashboardCategory?: string) => void
    onClickEdit?: (dashboard: DashboardType) => void
    viewMode?: "grid" | "list"
}

export function DashboardCategory(props: DashboardCategoryProps) {
    const {enabled: byoEnabled} = useFeatureGatingEnabled("ui", "byo_dashboard");
    const {dispatchError} = useAppContext();
    const client = new EAIClient();
    const { toast } = useToast();

    const onClickFavorite = async (dashboard_id: number) => {
        const dashboard = props.cards.find(card => card.id === dashboard_id);
        const dashboardName = dashboard ? dashboard.name : "Dashboard";
        const categoryName = props.name;
        try {
            if (checkIfIsFavorite(dashboard_id)) {
                await client.deleteFavoriteDashBoard(dashboard_id);
                toast({
                    type: "info",
                    title: "Removed from Favorites",
                    message: `Dashboard "${dashboardName}" has been successfully removed from your favorites. (Category: ${categoryName})`
                });
            } else {
                await client.addFavoriteDashboard(dashboard_id);
                toast({
                    type: "success",
                    title: "Added to Favorites",
                    message: `Dashboard "${dashboardName}" has been successfully added to your favorites. (Category: ${categoryName})`
                });
            }
            props.mutate();
        } catch (e) {
            dispatchError(e);
        }
    };

    const checkIfIsFavorite = (dashboard_id: number) => {
        const favoriteDashboards = props.favorites;
        const dashboards = props.categories;
        for (const category in dashboards) {
            if (dashboards.hasOwnProperty(category)) {
                const isFavoriteDashboards = category === FAVORITE_DASHBOARDS;
                const orIsCustomOrder = category === ALL_DASHBOARDS;
                if (isFavoriteDashboards ){
                    const dashboardsInCategory = dashboards[category];
                    if (dashboardsInCategory.some(dash => dash && dash.id === dashboard_id)) {
                        return true;
                    }
                } else if (orIsCustomOrder) {
                    if (favoriteDashboards && favoriteDashboards.some(favDash => favDash.id === dashboard_id)) {
                        return true;
                    }
                }
            }
        }

        return false;
    };
    const renderCards = () => {
        // Deduplicate dashboards by ID to prevent duplicates after favoriting
        const dedupedCards = _.uniqBy(props.cards, "id");
        const cards: JSX.Element[] = [];
        _.forEach(dedupedCards, (card) => {
            if (card.dashboard_type === "BYODashboard" && !byoEnabled) {
                return;
            } else {
                cards.push(
                    <DashboardCard
                        dashboard={card}
                        onClickEdit={props.onClickEdit}
                        onClickDelete={props.onClickDelete ? () => props.onClickDelete!(card.name, card.category) : undefined}
                        key={`${card.name}-${card.id}`}
                        onClickFavorite={() => onClickFavorite(card.id)}
                        isFavorite={checkIfIsFavorite(card.id)}
                        viewMode={props.viewMode}
                    />
                );
            }
        });

        return cards;
    };
    return (
        <section>
            {props.name !== FAVORITE_DASHBOARDS ? (
                props.viewMode === "list" ? (
                    <div className="dashboard-category-list-view" key={props.name} id={props.orderBy === "group" ? Utils.getUrlFriendlyString(props.name) : undefined}>
                        <div className="dashboard-list-cards">
                            {renderCards()}
                        </div>
                    </div>
                ) : (
                    <div className="dashboard-category" key={props.name} id={props.orderBy === "group" ? Utils.getUrlFriendlyString(props.name) : undefined}>
                        {props.viewMode === "grid" && (
                            <div className="category-name">
                                {props.orderBy === "custom_order"
                                    ? "CUSTOMIZED"
                                    : props.orderBy === "name asc"
                                    ? "NAME A-Z"
                                    : props.orderBy === "name desc"
                                    ? "NAME Z-A"
                                    : props.orderBy === "group" && props.name}
                            </div>
                        )}
                        <div className="cards grid-view">
                            {renderCards()}
                        </div>
                    </div>
                )
            ) : <div>
                {/*
                    //! TO DO : make new condition to remove commented code below
                    <fieldset className="dashboard-category-favorite">
                        <legend className="category-name-favorites">FAVORITES</legend>
                        <div className="cards justify-content-center">
                            {props.cards.length !== 0 ? renderCards() : <p className="no-favorites-text">Click the star on each dashboard to view your favorites here.</p>}
                        </div>
                    </fieldset>
                */}
            </div>
            }
        </section>
    );
}
